import { lazy } from 'react';

export const MainContainer = lazy(() => import('../containers/MainContainer'));
export const ShowJSONContainer = lazy(() => import('../containers/ShowJSONContainer'));
export const ImportJSONContainer = lazy(() => import('../containers/ImportJSONContainer'));
